import { roundToNearestMinutes } from 'date-fns'

export const TIME_INTERVAL = 15
export const currentDateRounded = roundToNearestMinutes(new Date(), {
  nearestTo: TIME_INTERVAL,
  roundingMethod: 'ceil',
})
